export enum FirebaseAuthErrors {
  InvalidEmail = 'auth/invalid-email',
  UserNotFound = 'auth/user-not-found',
  WrongPassword = 'auth/wrong-password',
  UserDisabled = 'auth/user-disabled',
  TooManyRequests = 'auth/too-many-requests',
  CustomTokenMismatch = 'auth/custom-token-mismatch',
  InvalidCustomToken =  'auth/invalid-custom-token',
}
